const PRIMARY_GUEST_DOB_NOTE_PREFIX = "Geburtsdatum Hauptreisende/r:";

/** Entfernt veraltete Geburtsdatum-Zeilen aus Buchungsnotizen (früher als Notiz gespeichert). */
export function displayBookingNotes(notes: string | null | undefined): string | null {
  if (!notes?.trim()) return null;
  const filtered = notes
    .split("\n")
    .filter((line) => !line.trim().startsWith(PRIMARY_GUEST_DOB_NOTE_PREFIX))
    .join("\n")
    .trim();
  return filtered || null;
}
